import { DataGrid } from 'devextreme-react';
import { t } from 'i18next';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import { roleService } from '@/core/services/role-service';

const RoleList = () => {
    const dataGridRef = useRef<DataGrid>(null);
    const [mainStore] = useState(new CustomStore({
        key: ['id'],
        load: roleService.roleList,
        byKey: async (key, loadOptions: any) => {
            let returnObject = null;
            if (key) {
                loadOptions.filter = ["id", "=", key];
                const objectsByID = (await roleService.roleList(loadOptions))
                returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
            }
            return returnObject
        },
        useDefaultSearch: true
    }));

    const navigate = useNavigate();

    const goToEdit = (id: string) => {
        navigate(`/role-definition/${id}`, { state: { id: id } })
    }

    return (
        <>

            <DataGridWrapper
                datasource={mainStore}
                permissonCode='Role.Role'
                props={{ id: 'role-list', ref: dataGridRef, wordWrapEnabled: true }}
                editingConfig={{ allowUpdating: true, confirmDeleteMessage: RemoveMessage(t('role')) }}
                pagerVisible={true}
                headerFilterVisible={true}
                filterVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath='/role-definition'
                columns={[
                    {
                        dataField: 'name',
                        caption: t('role_name'),
                        allowSearch: true,
                    },
                    {
                        dataField: 'description',
                        caption: t('role_description'),
                        allowSearch: true,
                    },
                    {
                        dataField: 'applicationName',
                        caption: t('application'),
                        allowSearch: true,
                    },
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: (e: any) => goToEdit(e.row?.data.id),
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </>
    )
}
export default RoleList